import { auth } from '../firebase/config';
import { RolePermissions } from '../models/data';

const BACKEND_BASE_URL =
  import.meta.env.VITE_BACKEND_BASE_URL ||
  import.meta.env.VITE_FUNCTIONS_BASE_URL ||
  'https://mintleaf-foglalasok-4-ai-copy.onrender.com';

const getAuthToken = async (): Promise<string> => {
  const sessionToken = window.localStorage.getItem('mintleaf_api_token');
  if (sessionToken) return sessionToken;

  const user = auth.currentUser;
  if (!user) throw new Error('UNAUTHENTICATED');
  return user.getIdToken();
};

const request = async <T>(path: string, init: RequestInit = {}): Promise<T> => {
  const token = await getAuthToken();
  const response = await fetch(`${BACKEND_BASE_URL}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(init.headers || {}),
    },
  });

  if (!response.ok) {
    let payload: any = null;
    try {
      payload = await response.json();
    } catch {
      payload = null;
    }
    const error = new Error(payload?.message || 'PERMISSIONS_API_ERROR');
    (error as any).statusCode = response.status;
    throw error;
  }

  return response.json() as Promise<T>;
};

export type GlobalPermissionsResponse = RolePermissions;

export const getGlobalPermissions = () =>
  request<GlobalPermissionsResponse>('/api/permissions');

export const updateGlobalPermissions = (payload: RolePermissions) =>
  request<GlobalPermissionsResponse>('/api/permissions', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
